import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import { loadAndAssert } from '../authz/access.js';
import { Conversation, type Message } from '../conversation.js';
import { Feedback } from '../feedback.js';

export const giveFeedbackMutation = registerMutation({
  operationName: 'giveFeedbackMutation',
  type: () => Boolean,
  params: [
    { name: 'conversationId', type: () => String },
    { name: 'messageId', type: () => String },
    { name: 'vote', type: () => String },
    { name: 'feedback', type: () => String },
  ],
  resolve: (conversationId: string, messageId: string, vote: 'up' | 'down', feedback: string) => async () => {
    // Feedback has no author field; tying it to the caller's own conversation is what attributes it.
    await loadAndAssert(Conversation, conversationId, 'read', { _id: 1 });
    const conversationCollection = await getCollection(Conversation);
    const conversation = await conversationCollection.findOne({ _id: conversationId });

    if (!conversation) {
      throw new Error(`Conversation ${conversationId} not found`);
    }

    const allMessages = (conversation?.messages ?? []);
    const targetIndex = allMessages.findIndex(
      msg => msg._id === messageId || (msg as unknown as { id?: string }).id === messageId,
    );
    const context = targetIndex >= 0 ? allMessages.slice(0, targetIndex + 1) : allMessages;

    const feedbackDoc = new Feedback({
      conversationId,
      messageId,
      vote,
      feedback,
      timestamp: new Date().toISOString(),
      context,
    });

    await (await getCollection(Feedback)).insertOne(feedbackDoc.toObject());

    return true;
  },
});
